// apps/frontend/src/features/experiential/lib/schemaModes.ts
import { SchemaModeKey } from "../types";

export const SONIOX_VOICES: string[] = [
  "Maya", "Daniel", "Noah", "Nina", "Emma", "Jack", "Adrian", "Claire",
  "Grace", "Owen", "Mina", "Kenji", "Rafael", "Mateo", "Lucia", "Sofia",
  "Oliver", "Arthur", "Isla", "Victoria", "Cooper", "Mason", "Ruby", "Elise",
  "Arjun", "Rohan", "Priya", "Meera",
];

interface ModeDef { key: SchemaModeKey; defaultVoice: string; }

export const SCHEMA_MODES: ModeDef[] = [
  { key: "punitive_parent", defaultVoice: "Daniel" },
  { key: "demanding_parent", defaultVoice: "Arthur" },
  { key: "vulnerable_child", defaultVoice: "Nina" },
  { key: "angry_child", defaultVoice: "Jack" },
  { key: "impulsive_child", defaultVoice: "Owen" },
  { key: "happy_child", defaultVoice: "Ruby" },
  { key: "detached_protector", defaultVoice: "Mason" },
  { key: "compliant_surrenderer", defaultVoice: "Claire" },
  { key: "healthy_adult", defaultVoice: "Grace" },
  { key: "custom", defaultVoice: "Maya" },
];

export function defaultVoiceForMode(key: SchemaModeKey): string {
  return SCHEMA_MODES.find((m) => m.key === key)?.defaultVoice ?? "Maya";
}
